import React from 'react';
import Toggle from 'react-bootstrap-toggle';

export const ToggleButton = (props) => (
  <Toggle
    on="on"
    off="off"
    size="sm"
    className="toggle-switch"
    active={props.value === true}
    onClick={(value) => props.onChange(value)}
  />
);

export const DisabledToggleButton = (defaultValue = true) =>
  function DisabledToggleWithDefault() {
    return (
      <Toggle
        active={defaultValue}
        on="on"
        off="off"
        size="sm"
        className="toggle-switch"
        disabled
      />
    );
  };

export const ReverseToggleButton = (props) => (
  <Toggle
    on="on"
    off="off"
    size="sm"
    className="toggle-switch"
    active={props.value === false}
    onClick={(value) => {
      props.onChange(!value);
    }}
  />
);
